import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getSpecialistSets = api(async function specialistSetsForRules() {
    return query(
        gql`
            query SpecialistSetsForRules {
                specialistSetsForRules {
                    id
                    name
                }
            }
        `,
        {},
        { returns: "specialistSetsForRules" }
    )
})
